import routerMap from "./path_comp_Map.js";
// import Index from '@/views/index';//首页
import Router from "@/router"
function deepRouterFunc(arr) {
    const isArray = Array.isArray(arr);
    if (!isArray || isArray && arr.length == 0) return;
    return arr.map(menu => {
        const { subMenuList, id, menuName, menuPath, menuType, order, permissionCode } = menu;
        const tempObj = {};
        if (Array.isArray(subMenuList) && subMenuList.length != 0) {
            tempObj.children = deepRouterFunc(subMenuList);
        }
        const mapIns = routerMap[menuPath] || {};
        return {
            path: menuPath,
            name: mapIns.name,
            component: mapIns.component,
            ...tempObj,
            meta: {
                path:menuPath,
                requireAuth: true,
                title: menuName,
                menuType,
                order,
                id,
                permissionCode,
            }
        }
    })
}


const IndexImport = () => import("@/views/index");

export default (authorityMenuArr = []) => {
    let dynamicRoutes = deepRouterFunc(authorityMenuArr);
    //给第一层附加Index
    dynamicRoutes = dynamicRoutes.map(item => {
        item.component = IndexImport;
        //路由重定向
        const children = item.children;
        if (Array.isArray(children) && children.length != 0) {
            item.redirect = children[0].path;
        }
        return item;
    })
    console.log("dynamicRoutes", dynamicRoutes);
    dynamicRoutes.forEach(item => {
        Router.addRoute(item);
    });
    const initRouterPath = dynamicRoutes[0].redirect || dynamicRoutes[0].path;
    console.log("initRouter jump", initRouterPath);
    Router.replace(initRouterPath);

    return dynamicRoutes;
}




// WEBPACK FOOTER //
// ./src/router/renderFunc.js